import { createSlice } from '@reduxjs/toolkit';
import {updateApprovalCommunityData} from '../CommunityAPI/communityApi';

const updateApprovalCommunityDataSlice = createSlice({
  name: 'updateApprovalCommunityData',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(updateApprovalCommunityData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateApprovalCommunityData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateApprovalCommunityData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});
export default updateApprovalCommunityDataSlice.reducer;
